import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ContextService, Typology } from '@bcef/ia-shared';
import { WA_WINDOW } from '@ng-web-apis/common';
import { Observable } from 'rxjs';

import { Config, CustomWindowResilContrats } from '@features/termination/interfaces';

import { ConnectionContextService } from './connection-context.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly windowRef = inject<CustomWindowResilContrats>(WA_WINDOW);

  private readonly connectionContextService: ConnectionContextService =
    inject(ConnectionContextService);

  private readonly contextService: ContextService = inject(ContextService);

  private readonly http: HttpClient = inject(HttpClient);

  public getConfig(): Observable<Config> {
    return this.http.get<Config>(
      `/apps/ia-resil-contrats/config/${this.environment}/ia-resil-contrats-${this.contextService.typology}${this.isHbConnected}-V1.json`,
    );
  }

  private get environment(): string {
    return this.windowRef.ENV || 'prod';
  }

  private get isHbConnected(): string {
    return this.contextService.typology === Typology.HB && this.connectionContextService.isConnected
      ? '-connected'
      : '';
  }
}
